import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { StyledSection, Wrapper } from "./styles";

import BlogCard from "./components/blogCard";
import blogData from "../../assets/Blogs/blogdata";

const BlogsPage = () => {
  const [mediumData, setMediumData] = useState([]);

  console.log(mediumData);

  return (
    <StyledSection>
      <Wrapper>
        <div id="blog" className="container mt-6">
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h6
              style={{
                marginBottom: "30px",
                alignSelf: "center",
                fontSize: "44px",
                fontWeight: "bold",
              }}
            >
              Our Blogs
            </h6>
          </div>

          <div className="blog-grid" id="blog-grid-id">
            {[...blogData]
              .sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate))
              .map((blog) => (
                <BlogCard key={blog.id} blog={blog} />
              ))}
          </div>
        </div>
      </Wrapper>
    </StyledSection>
  );
};

export default BlogsPage;
